import React, { PureComponent } from 'react'

import Menu from '@material-ui/core/Menu'
import { MenuItem } from '@material-ui/core'
import { translate } from 'components/shared/internationalization/Trans'
import { Subtitle } from 'components/shared/typography/Typography'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { actions as editorActions } from 'reducers/minuteTakerReducer'
import { connect } from 'react-redux'
//import { EDITOR_TABS } from 'components/minutetaker/components/InvitationView/types'

type Status = 'draft' | 'inReview' | 'reviewed' | 'approved'

type StatusPopoverProps = {
    onClosePopover: ({ closeReason }: { closeReason: Status }) => void
    onStatusChange: (status: Status, prevStatus?: Status) => void
    onRequestCloseExportPopover: () => void
    isOpen: boolean
    anchorElement: any
    closeReason?: string
    actions: {
        currentSelectedTab: (...args: any[]) => void
    }
}

const menuItems = [
    {
        primaryText: translate('DRAFT'),
        value: 'draft'
    },
    {
        primaryText: translate('IN_REVIEW'),
        value: 'in_review'
    },
    {
        primaryText: translate('FINAL_DRAFT'),
        value: 'final_draft'
    },
    {
        primaryText: translate('APPROVED'),
        value: 'approved'
    }
]

class StatusPopover extends PureComponent<StatusPopoverProps> {
    onClosePopover = (closeReason, prevStatus) => {
        this.props.onClosePopover({ closeReason })
        this.props.onStatusChange(closeReason, prevStatus)
        // This is removed since we want to keep the same tab after changing Document status, and this code changes the tab to editor tab on status change
        // this.props.actions.currentSelectedTab(EDITOR_TABS.EDITOR)
    }

    render() {
        const { isOpen, onRequestCloseExportPopover, anchorElement, closeReason } = this.props
        const anchorOrigin: any = { horizontal: 'left', vertical: 'bottom' }
        const targetOrigin: any = { horizontal: 'left', vertical: 'top' }

        return (
            <Menu
                open={isOpen}
                anchorEl={anchorElement}
                anchorOrigin={anchorOrigin}
                transformOrigin={targetOrigin}
                onClose={onRequestCloseExportPopover}
                getContentAnchorEl={null}>
                {menuItems.map((menuItem) => (
                    <MenuItem
                        key={`popover-menu-item-${menuItem.value}`}
                        data-testid={`DocumentStatusMenuItem-${menuItem.value}`}
                        // TODO: for status logic of review process
                        className="dropDownFocus"
                        style={{ paddingRight: '75px' }}
                        onClick={this.onClosePopover.bind(this, menuItem.value, closeReason)}
                        selected={!!closeReason && closeReason === menuItem.value}>
                        <Subtitle type="subtitle1">{menuItem.primaryText}</Subtitle>
                    </MenuItem>
                ))}
            </Menu>
        )
    }
}

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    const { currentSelectedTab } = editorActions
    return {
        actions: bindActionCreators(
            {
                currentSelectedTab
            },
            dispatch
        )
    }
}

export default connect(null, mapDispatchToProps)(StatusPopover)
